

class StringUtil {

    addSpacePaddingRightLeft(str, fixLength ){
        // เพิ่ม 2 ข้างเท่าๆ กัน
        let curLen = str.length;
        let lenAll = Number(fixLength);
        let lenSpace = lenAll - curLen;

        // console.log(str, ' len:', curLen)

        let strNew = str;
        if(lenSpace > 0) {
            let lenSpaceHaft = parseInt(String(lenSpace/2));
            if(lenSpaceHaft > 0) {
                let space=''
                for(let i=0; i < lenSpaceHaft ;i++){
                    space+=' ';
                }

                return space+strNew+space;
            }
        }
        return strNew;
    }

    addSpacePaddingFill(str, fixLength ){
        // เพิ่มหน้า 5 เ
        let curLen = str.length;
        let lenAll = Number(fixLength);

        if(curLen === 0) {
            str = '-';
            curLen = 1;
        }

        let lenSpace = lenAll - curLen;

        let strNew = str;
        if(lenSpace > 0) {

                let space=''
                let spaceStart= '     ' // 5 space
                let lenSpaceEnd = lenSpace - spaceStart.length

                for(let i=0; i < lenSpaceEnd ;i++){
                    space+=' ';
                }

                return spaceStart+strNew+space;
        }
        return strNew;
    }

}

export default new StringUtil();
